/*
 * BrightLabs Proprietary Limited (c) 2021
 * https://www.brightlabs.co.bw
 * info@brightlabs.co.bw
 */

import React from "react";
import {Icon, Stack, Text} from "@fluentui/react";
import Slide from 'react-reveal';
import {Link} from "react-router-dom";

import Page from "../shared/Page";
import ResizablePage from "../shared/ResizablePage";

import helpers from "../../k/helpers";

import hero from "../../images/illustrations/services.svg";
import web_dev from "../../images/illustrations/services_dev_web.svg";
import custom_dev from "../../images/illustrations/services_dev_custom.svg";
import o365_dev from "../../images/illustrations/services_dev_0365.svg";
import android_dev from "../../images/illustrations/services_dev_android.svg";
import ios_dev from "../../images/illustrations/services_dev_ios.svg";
import devops from "../../images/illustrations/services_devops.svg";
import design from "../../images/illustrations/services_design.svg";
import Hero from "../shared/Hero";


class HeroContent extends React.Component<any, any> {

    public render() {

        const
            padding = helpers.padding();

        return (
            <Stack tokens={{childrenGap: padding}}>

                <Stack>

                    <Slide left>
                        <Stack tokens={{childrenGap: -16}}>
                            <h4>
                                {helpers.links.services.text}
                            </h4>

                            <h1>
                                Our services
                            </h1>
                        </Stack>
                    </Slide>

                    <Slide right>
                        <h2>
                            Let's craft something.
                        </h2>
                    </Slide>

                </Stack>


                <Slide bottom>
                    <Stack verticalFill={true} verticalAlign={'center'} horizontalAlign={'center'}>
                        <h3>
                            We plan, design & develop digital products that people use and love.
                        </h3>

                        <h3>
                            We work in partnership or as an extension of your team to help make an impact in today’s digitally led world.
                        </h3>
                    </Stack>
                </Slide>

            </Stack>
        );
    }
}

class AdditionalContent extends React.Component<any, any> {

    private services = [
        {
            ...helpers.links.web_dev,
            icon: web_dev,
            description: 'We provide JavaScript, .NET and PHP development. Let us help you build a great product by ' +
                'using frameworks like Symfony, Laravel, React, Vue.js, Node.js.',
        },
        {
            ...helpers.links.custom_dev,
            icon: custom_dev,
            description: 'We help enterprises and startups with creating custom software. Digital Transformation, ' +
                'Systems Integrations and Internet of Things applications.'
        },
        {
            ...helpers.links.o365_dev,
            icon: o365_dev,
            description: 'As a Microsoft Partner, we build solutions that harness the power of the Microsoft 365 platform, ' +
                'to help you expand the reach of your solutions to new customers, partners and markets.'
        },
        {
            ...helpers.links.android_dev,
            icon: android_dev,
            description: 'Using Google’s latest technologies, our Android app development team delivers 100% native ' +
                'and reliable high-quality apps, with seamless integration with your backend.'
        },
        {
            ...helpers.links.ios_dev,
            icon: ios_dev,
            description: 'We have a passionate and dedicated iOS development team that crafts 100% native iOS and ' +
                'macOS applications using only Apple’s tools and frameworks.'
        },
        {
            ...helpers.links.devops,
            icon: devops,
            description: 'We provide cloud management services, build architectures for applications in the ' +
                'Cloud (Azure, AWS), configure CI/CD Processes and provide maintenance & monitoring services.'
        },
        {
            ...helpers.links.design,
            icon: design,
            description: 'Beautifully designed and user-friendly applications will help you stand out from ' +
                'the competition. UX/UI design plays a significant role in the development process.'
        }
    ];

    public render() {

        const
            padding = helpers.padding();

        return (
            <Stack
                verticalAlign={'center'}
                style={{padding: padding}}>

                <div className={'ms-Grid-row'} id={'service-links'}>
                    <Slide bottom>
                    {
                        this.services.map(service => {
                            return (
                                <div
                                    className={'ms-Grid-col ms-sm12 ms-lg6  ms-xl4'}
                                    style={{marginBottom: 8, marginTop: 8}}>

                                    <Link
                                        to={service.url}
                                        className={'service-link'}>

                                        <Stack tokens={{padding: 16, childrenGap: 16}}>

                                            <img src={service.icon} alt={service.text} style={{height: 48, width: 48}} />

                                            <h3>
                                                {service.text}
                                            </h3>

                                            <div className={'service-link-details'}>

                                                <Stack tokens={{childrenGap: 16}} verticalFill={true} verticalAlign={'space-between'}>

                                                    <Text variant={'smallPlus'} style={{lineHeight: '180%'}}>
                                                        {service.description}
                                                    </Text>

                                                    <Stack horizontal={true} verticalAlign={'center'} horizontalAlign={'space-between'} tokens={{childrenGap: 4}}>
                                                        <Text variant={'small'} className={'sub-link'}>
                                                            Learn more
                                                        </Text>
                                                        <Icon iconName={'ArrowTallDownRight'} className={'sub-link'} style={{fontSize: 12, fontWeight: 500, transform: 'rotate(-45deg)'}} />
                                                    </Stack>

                                                </Stack>

                                            </div>

                                        </Stack>

                                    </Link>

                                </div>
                            );
                        })
                    }
                    </Slide>
                </div>

            </Stack>
        );
    }
}

export default class Services extends ResizablePage {

    public render() {

        const
            backgroundColor = 'rgba(0, 0, 0, 0.003)',
            backgroundSize = '30%',

            title = "BrightLabs | " + helpers.links.services.text,
            url = helpers.links.services.url,
            description = "Custom web, iOS, Android and Office 365 app development, DevOps, CI/CD, UI/UX design and workshops";

        return (
            <Page title={title} description={description} url={url}>

                <Hero backgroundColor={backgroundColor} backgroundSize={backgroundSize} hero={hero} showMore={true}>
                    <HeroContent />
                </Hero>

                <AdditionalContent />

            </Page>
        );
    }
}
